import styled, { css } from 'styled-components';
import { Typography, Wrapper } from '@trader/components';

export const Root = styled(Wrapper)`
  ${() => css`
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `}
`;

export const Header = styled(Wrapper)`
  ${({ theme }) => css`
    width: 100%;
    align-items: center;
    margin-bottom: 35px;
    padding: 0 10px 20px 10px;
    border-bottom: 1px solid ${theme.palette.gray.main};
  `}
`;

export const Title = styled(Typography)`
  ${() => css`
    font-size: 18px;
    font-weight: 700;
  `}
`;

export const VolumeContainer = styled(Wrapper)`
  ${() => css`
    margin: 25px 0;
  `}
`;

export const Volume = styled(Typography)`
  ${({ theme }) => css`
    font-size: 18px;
    font-weight: 700;
    margin-left: 5px;
    color: ${theme.palette.green.main};
  `}
`;
export const Instrument = styled(Typography)`
  ${() => css`
    font-size: 15px;
    font-weight: 700;
  `}
`;
export const Price = styled(Typography)`
  ${() => css`
    font-size: 12px;
    font-weight: 400;
  `}
`;
export const Success = styled(Typography)`
  ${({ theme }) => css`
    font-size: 18px;
    font-weight: 700;
    margin-top: 20px;
    color: ${theme.palette.green.main};
  `}
`;
